import React from 'react';
import { CmsButton } from '../../types/contentstack';
import LinkIcon from '../icons/LinkIcon';

interface CmsPageHeaderData {
  name?: string;
  component?: string;
  headline?: string;
  paragraph_text?: string;
  button?: CmsButton[];
  horizon?: unknown[];
  _metadata?: {
    uid: string;
  };
}

interface CmsPageHeaderProps {
  data: CmsPageHeaderData;
  className?: string;
}

const getButtonClassName = (button: CmsButton): string => {
  const baseClasses = 'inline-flex items-center gap-2 rounded-md font-semibold transition-colors';

  if (button.variant === 'filled') {
    if (button.inverted) {
      return `${baseClasses} bg-white text-[#0054A4] hover:bg-gray-100 px-6 py-3`;
    }
    return `${baseClasses} bg-[#0054A4] text-white hover:bg-blue-700 px-6 py-3 border-2 border-white`;
  }

  return `${baseClasses} text-white hover:text-gray-200 px-6 py-3 border-2 border-white`;
};

export const CmsPageHeader: React.FC<CmsPageHeaderProps> = ({ data, className = '' }) => {
  return (
    <section className={`relative w-full bg-[#0054A4] pt-[64px] pb-800 px-500 ${className}`}>
      <div className="mx-auto">
        <div className="flex flex-col md:flex-row items-start gap-[280px]">
          {data.headline && (
            <div className="flex-shrink-0">
              <h2 className="text-white text-lg md:text-xl font-semibold">{data.headline}</h2>
            </div>
          )}

          <div className="flex-1">
            {data.paragraph_text && (
              <p className="text-white text-[32px] font-bold leading-tight mb-4">
                {data.paragraph_text}
              </p>
            )}

            {data.button && data.button.length > 0 && (
              <div className="flex gap-3">
                {data.button.map((button) => (
                  <a
                    key={button.text}
                    href={button.url}
                    target={button.external ? '_blank' : '_self'}
                    rel={button.external ? 'noopener noreferrer' : undefined}
                    className={getButtonClassName(button)}
                  >
                    {button.text}
                    <LinkIcon
                      type={button.icon}
                      className={button.icon === 'ExternalIcon' ? 'w-4 h-4' : 'w-5 h-5'}
                    />
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CmsPageHeader;
